module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcthigh2-2d7bcc294417acb6afba69486c747abb.jpg";